<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 11 22">
    <g clip-path="url(#clip0_6892_8983)">
      <path
        d="M10.7778 7.20824L10.3864 11H7.43187V22H2.98743V11H0.777832V7.20824H2.98743V4.93059C2.98743 1.83765 4.23743 0 7.79803 0H10.7526V3.79176H8.89652C7.52026 3.79176 7.41925 4.32235 7.41925 5.31882V7.20824H10.7652H10.7778Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8983">
        <rect width="10" height="22" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
